import { p } from '@/utils/content-blocks';

/** About 页正文区块 */
export const ABOUT_SECTIONS = [
	{
		id: 'what-is-gbwaps',
		h2: 'What Is GBWaps?',
		blocks: [
			p([
				{
					text: 'GBWaps is an independent guide site for Android users who want clear help with ',
				},
				{ link: { to: '/', text: 'GB WhatsApp' } },
				{
					text: ' — download steps, install walkthroughs, update tips, feature explainers, and fixes when something breaks. We are not WhatsApp, Meta, or any mod developer. We publish practical tutorials in plain English so you can decide what to install and how to use it more safely.',
				},
			]),
			p([
				{
					text: 'Our focus is simple: get you to the right APK info, show you how to sideload without losing chats, and point you to deeper pages when you need them — like the ',
				},
				{ link: { to: '/download/', text: 'Download GB WhatsApp APK' } },
				{ text: ' hub or the ' },
				{ link: { to: '/faq/', text: 'GB WhatsApp FAQ' } },
				{ text: ' when you have a specific question.' },
			]),
		],
	},
	{
		id: 'what-we-publish',
		h2: 'What We Publish',
		blocks: [
			p([
				{
					text: 'You will find step-by-step guides (install, update, troubleshooting), feature breakdowns, anti-ban usage notes, and occasional ',
				},
				{ link: { to: '/blog/', text: 'blog posts' } },
				{
					text: ' on crashes, bans, and how GB WhatsApp compares to the official app. Every page is written for real problems — not filler SEO paragraphs.',
				},
			]),
			p([
				{
					text: 'When we list a version number or file size, we aim to match what you should see on the download page before you tap install. If something on your phone does not match, treat our ',
				},
				{ link: { to: '/gbwhatsapp-update/', text: 'GB WhatsApp update guide' } },
				{ text: ' or ' },
				{ link: { to: '/troubleshooting/', text: 'troubleshooting hub' } },
				{ text: ' as the next stop instead of forcing an old APK.' },
			]),
		],
	},
	{
		id: 'editorial-approach',
		h2: 'How We Write Guides',
		blocks: [
			p([
				{
					text: 'We describe GB WhatsApp as an unofficial enhanced Android client — a mod version — not an “official” WhatsApp product. We do not promise zero ban risk, cracked features, or anything that violates platform rules. If a setting can get your number flagged, we say so and link to our ',
				},
				{ link: { to: '/anti-ban/', text: 'anti-ban guide' } },
				{ text: ' instead of overselling safety.' },
			]),
			p([
				{
					text: 'Guides are updated when login rules, APK sizes, or common errors change. We welcome corrections: outdated screenshots, wrong version labels, or broken links help nobody. Use ',
				},
				{ link: { to: '/contact-us/', text: 'Contact Us' } },
				{
					text: ' if you spot something wrong — we read feedback regularly even if we cannot reply to every message the same day.',
				},
			]),
		],
	},
	{
		id: 'what-we-do-not-do',
		h2: 'What GBWaps Does Not Do',
		blocks: [
			p([
				{
					text: 'We do not host official WhatsApp support, recover banned accounts, restore deleted chats, or remove restrictions on your number. We cannot reset verification codes or access your device remotely. For account-level issues, you are still dealing with WhatsApp’s own systems and whatever backup you saved before a reinstall.',
				},
			]),
			p([
				{
					text: 'Downloading any third-party APK is your choice. Scan files when you can, avoid random mirror sites, and keep a backup before updates. Our ',
				},
				{ link: { to: '/disclaimer/', text: 'Disclaimer' } },
				{ text: ' and ' },
				{ link: { to: '/privacy-policy/', text: 'Privacy Policy' } },
				{ text: ' explain site limits in more detail.' },
			]),
		],
	},
	{
		id: 'start-here',
		h2: 'Where to Start',
		blocks: [
			p([
				{ text: 'New here? Pick one path:' },
			]),
		],
		list: [
			'Ready to install → open the download page, then follow the install guide.',
			'Already on GB WhatsApp → check version in About, then read the safe update steps.',
			'Something broken → use troubleshooting or search the FAQ accordion.',
			'Worried about bans → read anti-ban tips before turning on every privacy toggle.',
		],
		footerLinks: [
			{ to: '/download/', text: 'Download GB WhatsApp APK' },
			{ to: '/install-gbwhatsapp/', text: 'How to Install GB WhatsApp APK' },
			{ to: '/features/', text: 'GB WhatsApp Features' },
		],
	},
];
